export default "__VITE_ASSET__B78EXjiv__"